import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, IAppState, IMicrositeResponse, MicrositeActionCreators } from '@nkr/store/index';
import { IMicrositeRecipient } from '@nkr/models/index';
import { Button  } from 'react-bootstrap';
import MicrositeHistory from './microsite-history';
import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';

interface IProps {
    micrositeId: number,
    centerId: number,
    isAdmin: boolean,
    previousUrl: string,
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getMicrosite: (id: number, forCoach: boolean) => Promise<IMicrositeResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const MicrositeRecipientHistory = (props:TProps) => {
    const location = window.location;
    const params = new URLSearchParams(location.search);
    const returnTo = params.get('returnTo');

    const [recipient, setRecipient] = useState<IMicrositeRecipient>(null);
            
    useEffect(() => {
        props.showLoading('Getting the microsite, one moment please...').then(() => {
            props.getMicrosite(props.micrositeId, false).then(response => {
                if (response.data.success) {
                    setRecipient(response.data.results)
                }
                props.hideLoading();
            }).catch((error: AxiosError) => {
                props.hideLoading();
            });
        });
    }, [props.micrositeId]);

    const handleCancel = () => {
        if (returnTo) {
            window.location.href = `/${returnTo}`;
            return;
        }
        const previousLocation = props.isAdmin ? `/admin/microsite/${props.previousUrl}` : `/center/${props.centerId}/microsite/${props.previousUrl}`;
        window.location.href = previousLocation;
    }
    
    if (!recipient) {
        return (<div>One moment please...</div>);
    }

    const { submissionLastIssue, fullName, logs } = recipient;
    
    return (<>
        <div className='container'>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20, marginBottom: 20 }}>
                <h1 style={{ margin: 0 }}>Activity Summary for {fullName}</h1>
                <div className="dropdown pull-right">
                    <Button bsStyle='link' onClick={handleCancel}>Return to List</Button>
                </div>
            </div>

            <form action='' method='post'>
                <div className='row'>
                    {submissionLastIssue != '' && (
                        <div className='col-xs-12'>
                            <MicrositeHistory
                                name={fullName}
                                logs={logs}
                                isExpanded={true}
                            />
                        </div>
                    )}
                </div>
            </form>
        </div>
    </>);
}


const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { return dispatch(AppActionCreators.hideLoading()); },
        getMicrosite: (id, forCoach) => { return dispatch(MicrositeActionCreators.getMicrosite(id, forCoach)); }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(MicrositeRecipientHistory);